<template>
  <el-popover placement="bottom" width="560" trigger="click" @show="handleShow">
    <template>
      <div class="freight-table-wrapper">
        <p class="freight-title">货运安排</p>
        <el-table
          :data="freightList"
          style="width: 100%"
          :summary-method="getSummaries"
          show-summary
          sum-text="总计"
        >
          <el-table-column prop="index" label="批次" width="70">
            <template slot-scope="scoped">
              {{ scoped.$index + 1 }}/{{ freightList.length }}
            </template>
          </el-table-column>
          <el-table-column prop="deliveryTime" label="交货日期">
            <template slot-scope="scoped">
              {{ moment(scoped.row.deliveryTime).format('YYYY-MM-DD') }}
            </template>
          </el-table-column>
          <el-table-column prop="num1" label="第一报价数量">
            <template slot-scope="scoped">
              <span v-if="scoped.row.num1">
                {{ scoped.row.num1 }}{{ quoteUnitStr }}
              </span>
              <span v-else> 0 </span>
            </template>
          </el-table-column>
          <el-table-column prop="num2" label="第二报价数量">
            <template slot-scope="scoped">
              <span v-if="scoped.row.num2">
                {{ scoped.row.num2 }}{{ quoteUnitStr }}
              </span>
              <span v-else> 0 </span>
            </template>
          </el-table-column>
          <el-table-column prop="num3" label="第三报价数量">
            <template slot-scope="scoped">
              <span v-if="scoped.row.num3">
                {{ scoped.row.num3 }}{{ quoteUnitStr }}
              </span>
              <span v-else> 0 </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>
    <slot name="reference" slot="reference"></slot>
  </el-popover>
</template>

<script>
import moment from 'moment'
export default {
  name: 'MyPopover',
  data() {
    return {}
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    freightList: {
      type: Array,
      default: () => [],
    },
    quoteUnitStr: {
      type: String,
      default: '',
    },
    totalMap: {
      type: Object,
      default: () => ({}),
    },
  },
  model: {
    prop: 'visible',
    event: 'changeVisible',
  },
  computed: {
    computedVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('changeVisible', val)
      },
    },
  },
  methods: {
    moment,
    handleShow() {},
    getSummaries(params) {
      const { columns, data } = params
      const sums = []
      columns.forEach((column, index) => {
        switch (index) {
          case 0:
            sums[index] = '总计'
            break
          case 1:
            sums[index] = ''
            break
          case 2:
          case 3:
          case 4:
            const key = `quoteNum${index - 1}`
            sums[index] = this.totalMap[key]
              ? `${this.totalMap[key]}${this.quoteUnitStr}`
              : 0
            break
          default:
            break
        }
      })
      return sums
    },
  },
}
</script>

<style scoped lang="scss">
/* SCSS or CSS here */
.freight-title {
  color: #222222;
  font-family: SourceHanSansCN-Bold !important;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 16px;
}
.freight-table-wrapper {
  padding: 4px;
}
:deep(.el-table) {
  color: #222222;
  font-family: SourceHanSansCN-Regular !important;
  th.el-table__cell {
    background: #e9edf1 !important;
    color: #555 !important;
  }
  .el-table__footer-wrapper tbody td.el-table__cell {
    background: #fff !important;
    color: #222 !important;
  }
  .el-table__footer-wrapper tbody td.el-table__cell:nth-child(1) {
    font-size: 14px;
    font-family: SourceHanSansCN-Medium !important;
  }
}
</style>
